import { render, staticRenderFns } from "./SizeProperty.vue?vue&type=template&id=50c66158&"
import script from "./SizeProperty.vue?vue&type=script&lang=js&"
export * from "./SizeProperty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports